import { useParams } from "react-router-dom";
import { ScreenOverlay, Spinner } from "../../components/Common";
import WorkSessionDetails from "./components/details";
import { toastError, toastSuccess } from "../../helpers/toast-helper";
import { getResponseItemData } from "../../helpers/response-helper";
import {
    useWorkSession,
    useWorkSessionAssignJob,
    useWorkSessionAssignOperator
} from "../../common/hooks/api/work-sessions";
import { useQueryClient } from "@tanstack/react-query";

const WorkSessionsDetailsPage = () => {
    const { id } = useParams();
    const { data: userResponse, isLoading, queryKey: workingSessionQueryKey } = useWorkSession(id, {
        onError: () => {
            toastError("Cannot fetch user data");
        },
    });
    const { data } = getResponseItemData(userResponse);

    const queryClient = useQueryClient();

    const { mutate: assignOperator } = useWorkSessionAssignOperator();
    const { mutate: assignJob } = useWorkSessionAssignJob();

    const onAssignOperator = ({ operatorId }) => {
        assignOperator(
            {
                workingSessionId: data?.id,
                operatorId,
            },
            {
                onSuccess: async () => {
                    await queryClient.invalidateQueries({ queryKey: workingSessionQueryKey });
                    await toastSuccess("Operator was successfully assigned to working session");
                },
                onError: () => {
                    toastError("Can not assign operator to working session");
                },
            }
        );
    };

    const onAssignJob = ({ jobId }) => {
        assignJob(
            {
                workingSessionId: data?.id,
                jobId,
            },
            {
                onSuccess: async () => {
                    await queryClient.invalidateQueries({ queryKey: workingSessionQueryKey });
                    await toastSuccess("Job was successfully assigned to working session");
                },
                onError: () => {
                    toastError("Can not assign job to working session");
                },
            }
        );
    };
    return (
        <>
            <WorkSessionDetails
                data={data}
                onAssignOperator={onAssignOperator}
                onAssignJob={onAssignJob}
            />
            {isLoading && (
                <>
                    <ScreenOverlay />
                    <Spinner />
                </>
            )}
        </>
    );
};

export default WorkSessionsDetailsPage;
